import React, { Component } from "react";

import { Button, Row, Col, FormGroup, Form, ControlLabel, FormControl } from "react-bootstrap";
import Switch from 'react-bootstrap-switch';

import Loading from "../../components/loading";
import SettingsModal from "../../components/settings-alert";

import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css";

import "./style.css";

import _ from 'underscore';
import { AsYouType } from 'libphonenumber-js';

import {ToastContainer, ToastStore} from 'react-toasts';
import UsersService from "../../services/users-service";
//import DatePicker from 'react-date-picker';
import DatePicker from 'react-16-bootstrap-date-picker';
import moment from 'moment';

class EditUser extends Component {
    constructor(props) {
        super(props);

        // this.toastManager = props;

        this.handleBackButton = this.handleBackButton.bind(this);
        this.handleSaveButton = this.handleSaveButton.bind(this);
        this.handleContinueButton = this.handleContinueButton.bind(this);
        this.handleExitButton = this.handleExitButton.bind(this);

        var credentials = UsersService.sharedInstance.getStoredCredentials();

        this.state = {
            credentials: credentials,
            recno: this.props.user ? this.props.user.recno : "",
            license: credentials.license,
            user_auth: credentials.username,
            token: credentials.token,
            message: '',
            isShowing: false,
            showWarningModal: false,
            hasChanged: false,
            branch: '',
            lms_active: false,
        }

        this.userTypeOptions = UsersService.sharedInstance.getUserTypeOptions('edit');
    }

    render() {
        return (
            <div>
                <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                <div className="controls-div">
                        <Button className="back-link-btn green-btn" onClick={this.handleBackButton}>Back To Users List</Button>
                        <Button className="control-btn green-btn"  onClick={this.handleSaveButton}>Save Changes</Button>
                        <Button className="control-btn gray-btn" onClick={this.handleBackButton}>Cancel</Button>
                </div>
                <div className="content-div">
                        {this.renderForm()}
                </div>
            </div>
        )
    }

    renderForm(){
        return(
            <div className="add-user-content">
                    <Form className="add-user-form">
                        { this.renderProfileSection() }
                        { this.renderPersonalInfoSection() }
                        { this.renderFooterButtons() }
                    </Form>
                    { <Loading isShowing={this.state.isShowing} message={this.state.message}/>}
                    <SettingsModal isShowing={this.state.showWarningModal} cancelButton={this.handleExitButton} continueButton={this.handleContinueButton}/>
            </div>
        )
    }

    componentWillMount(){
        UsersService.sharedInstance.getUserInfo(this.state.credentials.license, this.state.credentials.username, this.state.recno, this.state.credentials.token)
        .then((response)=>{
            var responseData = JSON.stringify(response);

            var user_info = response[0];
            this.setState({
                recno: UsersService.sharedInstance.returnEmptyIfNull(user_info.recno),
                password: UsersService.sharedInstance.returnEmptyIfNull(user_info.Password),
                username: UsersService.sharedInstance.returnEmptyIfNull(user_info.User_ID),
                user_type: UsersService.sharedInstance.returnEmptyIfNull(user_info.User_Type),
                street_address: UsersService.sharedInstance.returnEmptyIfNull(user_info.address),
                home_branch: UsersService.sharedInstance.returnEmptyIfNull(user_info.branch),
                city: UsersService.sharedInstance.returnEmptyIfNull(user_info.city),
                birth_date: user_info.date_of_birth !== "0000-00-00" ? new Date(user_info.date_of_birth).toISOString() : null,
                email_address: UsersService.sharedInstance.returnEmptyIfNull(user_info.email),
                employee_id: UsersService.sharedInstance.returnEmptyIfNull(user_info.employee_id),
                firstname: UsersService.sharedInstance.returnEmptyIfNull(user_info.first_name),
                lastname: UsersService.sharedInstance.returnEmptyIfNull(user_info.last_name),
                hire_date: user_info.hire_date !== "0000-00-00" ? new Date(user_info.hire_date).toISOString() : null,
                mobile_phone: UsersService.sharedInstance.returnEmptyIfNull(user_info.mobile_phone),
                notes: UsersService.sharedInstance.returnEmptyIfNull(user_info.notes),
                state: UsersService.sharedInstance.returnEmptyIfNull(user_info.state),
                work_phone: UsersService.sharedInstance.returnEmptyIfNull(user_info.work_phone),
                zip_code: UsersService.sharedInstance.returnEmptyIfNull(user_info.zipcode),
                branch: UsersService.sharedInstance.returnEmptyIfNull(user_info.branch),
                lms_active: user_info.lms_user_id == null ? false : true,
            })
        })
        .catch((error)=>{
            console.log("Error fetching users", error);
        })
    }

    handleBackButton(){
      if(this.state.hasChanged) {
        this.setState({showWarningModal: true});
      } else {
        this.handleExitButton();
      }
    }

    handleExitButton(){
        this.props.pageChange('default');
    }

    handleContinueButton(){
        this.setState({showWarningModal: false});
    }

    handleSaveButton(){

      var params = {
          "recno":this.state.recno,
          "license": this.state.license,
          "username": this.state.username,
          "password": this.state.password,
          "user_type": this.state.user_type,
          "token": this.state.token,
          "auth_username": this.state.user_auth,
          "email": this.state.email_address,
          "first_name": this.state.firstname,
          "last_name": this.state.lastname,
          "branch": this.state.branch,
          "hire_date": this.state.hire_date != null && this.state.hire_date != "" ? moment(this.state.hire_date).format("YYYY-MM-DD") : null,
          "employee_id": this.state.employee_id,
          "work_phone": this.state.work_phone,
          "notes": this.state.notes,
          "mobile_phone": this.state.mobile_phone,
          "address": this.state.street_address,
          "city": this.state.city,
          "state": this.state.state,
          "zipcode": this.state.zip_code,
          "date_of_birth": this.state.birth_date != null && this.state.birth_date != "" ? moment(this.state.birth_date).format("YYYY-MM-DD") : null,
          "create_litmos_user": this.state.lms_active != null && this.state.lms_active ? 1 : 0,
      }

        if(this.isValidForm(params)) {
          this.setState({showWarningModal: false, isShowing: true, message: 'Saving User...'});

          UsersService.sharedInstance.update_user(params)
          .then((response)=>{
              var responseData = JSON.stringify(response);

              if (response.success == 1 || response == true){
                  ToastStore.success("Successfully updated " + this.state.username + "'s information!");
                  this.handleExitButton();
              }
              else {
                  ToastStore.error("Error: " + response.message);
                  this.setState({isShowing: false});
              }
          })
          .catch((error)=>{
              console.log("Error fetching users", error);
          })
        } else {

        }

    }

    handleChange = event => {
        // this.setState({value: event.target.value});
        var value = event.target.value;
        if(event.target.id == "mobile_phone" || event.target.id == "work_phone") {
          value = value.replace(/\D/g, '');
        }
        this.setState({
            [event.target.id]: value,
            hasChanged: true,
        });
    }

    handleSwitch(elem, state) {
        this.setState({lms_active: state});
    }

    renderProfileSection(){
        let hasBranches = this.props.branches ? true : false;
        let branches = this.props.branches;
        return(
            <div className="user-section">
                <h3 className="sub-title">{this.props.user ? this.props.user.first_name + " " + this.props.user.last_name : ""}'s Profile</h3>
                <hr className="line"/>

                <div className="left-side-content">
                    <FormGroup controlId="firstname" bsSize="sm">
                        <ControlLabel className="login_label">First Name *</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.firstname}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="lastname" bsSize="sm">
                        <ControlLabel className="login_label">Last Name *</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.lastname}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="username" bsSize="sm">
                        <ControlLabel className="login_label">Username *</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.username}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="password" bsSize="sm">
                        <ControlLabel className="login_label">Password *</ControlLabel>
                        <FormControl
                            onChange={this.handleChange}
                            value={this.state.password}
                            type="password"
                        />
                    </FormGroup>
                    <FormGroup controlId="user_type" bsSize="sm">
                        <ControlLabel className="login_label">User Type *</ControlLabel>
                        <FormControl componentClass="select" placeholder="select" value={this.state.user_type} onChange={this.handleChange}>
                            <option value="">Select User Type</option>
                            {this.userTypeOptions}
                        </FormControl>
                    </FormGroup>
                </div>
                <div className="right-side-content">
                    <FormGroup controlId="home_branch" bsSize="sm">
                      <ControlLabel className="login_label">Branch *</ControlLabel>
                      <FormControl  componentClass="select" placeholder="Branch"
                         style={{width: "100%"}}
                         value={this.state.branch}
                         onChange={(e)=>{this.setState({branch: e.target.value})}}>
                          {hasBranches ? <option value={"select"}>Select Branch</option> : null}
                          {hasBranches
                              ? branches.map((branch) => {
                                  if(branch.is_active == 1)
                                    return <option key={branch.recno} value={branch.id}>{branch.branch_name}</option>
                                })
                              : <option disabled value="select">No Branch</option>
                          }
                      </FormControl>
                    </FormGroup>
                    <FormGroup bsSize="sm">

                        <ControlLabel htmlFor="hire_date">Hire Date</ControlLabel>
                        <DatePicker
                            id={"hire_date"}
                            onChange={(e)=> {
                              var fakeEvent = {target: { id: "hire_date", value: e}};
                                this.handleChange(fakeEvent)
                              }}
                            value={this.state.hire_date != "Invalid Date" ? this.state.hire_date : null}
                            minDate={new Date().toString()}
                            dateFormat={"MM-DD-YYYY"}
                            calendarIcon={null}
                            clearIcon={null}
                            />
                        {
                          // <DatePicker
                          //   id={"hire_date"}
                          //   onChange={(e)=> {
                          //     var fakeEvent = {target: { id: "hire_date", value: e}};
                          //       this.handleChange(fakeEvent)
                          //     }}
                          //   value={this.state.hire_date != "Invalid Date" ? this.state.hire_date : null}
                          //   minDate={new Date()}
                          //   className={["form-control", "pickerParent"]}
                          //   calendarClassName={"pickerCalendar"}
                          //   calendarIcon={null}
                          //   clearIcon={null}
                          // />
                        }
                    </FormGroup>

                    <FormGroup controlId="employee_id" bsSize="sm">
                        <ControlLabel className="login_label">Employee ID</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.employee_id}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="work_phone" bsSize="sm">
                        <ControlLabel className="login_label">Work Phone Number</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.strToPhoneNumber(this.state.work_phone)}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="notes" bsSize="sm">
                        <ControlLabel className="login_label">Notes</ControlLabel>
                        <FormControl
                            autoFocus
                            componentClass="textarea"
                            placeholder="Enter notes here..."
                            value={this.state.notes}
                            onChange={this.handleChange}
                        />
                    </FormGroup>

                </div>
            </div>
        )
    }

    renderPersonalInfoSection(){
        return(
            <div className="info-section">
                <h3 className="sub-title">Personal Information</h3>
                <hr className="line"/>

                <div className="left-side-content">
                    <FormGroup controlId="mobile_phone" bsSize="sm">
                        <ControlLabel className="login_label">Cell Phone Number</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.strToPhoneNumber(this.state.mobile_phone)}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="email_address" bsSize="sm">
                        <ControlLabel className="login_label">Email *</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.email_address}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup bsSize="sm">
                        <ControlLabel>Birth Date</ControlLabel>
                        <DatePicker
                            id={"birth_date"}
                            onChange={(e)=> {
                              var fakeEvent = {target: { id: "birth_date", value: e}};
                                this.handleChange(fakeEvent)
                              }}
                            value={this.state.birth_date != "Invalid Date" ? this.state.birth_date : null}
                            dateFormat={"MM-DD-YYYY"}
                            maxDate={new Date().toISOString()}
                            className="form-control"
                            calendarClassName={"pickerCalendar"}
                            calendarIcon={null}
                            clearIcon={null}
                            />
                        {
                          // <DatePicker
                          //     id={"birth_date"}
                          //     onChange={(e)=> {
                          //       var fakeEvent = {target: { id: "birth_date", value: e}};
                          //         this.handleChange(fakeEvent)
                          //       }}
                          //     value={this.state.birth_date != "Invalid Date" ? this.state.birth_date : null}
                          //     maxDate={new Date()}
                          //     className={["form-control", "pickerParent"]}
                          //     calendarClassName={"pickerCalendar"}
                          //     calendarIcon={null}
                          //     clearIcon={null}
                          //   />
                          }
                    </FormGroup>
                    <FormGroup controlId="create_lms">
                        {/* <ControlLabel className="login_label">Create LMS Account?</ControlLabel> */}
                        <h3 className="sub-title lms-title">Create e-Learning Account?</h3>
                        <div className="create-lms-div">
                            <Switch
                                onText = "YES"
                                offText = "NO"
                                value = {this.state.lms_active}
                                onChange={(el, state) => this.handleSwitch(el, state)}
                                name='create_lms' />
                        </div>
                    </FormGroup>
                </div>
                <div className="right-side-content">
                    <FormGroup controlId="street_address" bsSize="sm">
                        <ControlLabel className="login_label">Street Address</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.street_address}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="city" bsSize="sm">
                        <ControlLabel className="login_label">City</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.city}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <div className="state-section">
                        <FormGroup className="state-input" controlId="state" bsSize="sm">
                            <ControlLabel className="login_label">State</ControlLabel>
                            <FormControl
                                autoFocus
                                type="text"
                                value={this.state.state}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup className="zip-input" controlId="zip_code" bsSize="sm">
                            <ControlLabel className="login_label">Zip Code</ControlLabel>
                            <FormControl
                                autoFocus
                                type="text"
                                value={this.state.zip_code}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
        )
    }

    renderFooterButtons(){
        return(
                <div className="controls-div">
                    <Button className="control-btn green-btn" onClick={this.handleSaveButton}>Save Changes</Button>
                    <Button className="control-btn gray-btn" onClick={this.handleBackButton}>Cancel</Button>
                </div>
        )
    }

    isValidForm(params){
      var requiredFields = ["first_name",
                            "last_name",
                            "username",
                            "password",
                            "user_type",
                            "branch",
                            "email"];
      var validationForFields = [{name: "first_name", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str)}},
                            {name: "last_name", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str)}},
                            {name: "username", checkRegex: (str)=>{ return true}},
                            {name: "password", checkRegex: (str)=>{ return true}},
                            {name: "hire_date", checkRegex: (str)=>{

                                      var isCorrectFormat = true;///((0?[13578]|10|12)(-|\/)((0[0-9])|([12])([0-9]?)|(3[01]?))(-|\/)((\d{4})|(\d{2}))|(0?[2469]|11)(-|\/)((0[0-9])|([12])([0-9]?)|(3[0]?))(-|\/)((\d{4}|\d{2})))/.test(str)
                                      return isCorrectFormat || str == null || str.toString().replace(/ /g,'') == ''
                                    }
                            },
                            {name: "work_phone", checkRegex: (str)=>{
                                      return (/[0-9]/.test(str) && str.length == 10) || str == null || str.replace(/ /g,'') == ''
                                    }
                            },
                            {name: "mobile_phone", checkRegex: (str)=>{
                                      return (/[0-9]/.test(str) && str.length == 10) || str == null || str.replace(/ /g,'') == ''
                                    }
                            },
                            {name: "email", checkRegex: (str)=>{ return str.indexOf("@") >= 1}},
                            {name: "date_of_birth", checkRegex: (str)=>{
                                var isCorrectFormat = true;///((0?[13578]|10|12)(-|\/)((0[0-9])|([12])([0-9]?)|(3[01]?))(-|\/)((\d{4})|(\d{2}))|(0?[2469]|11)(-|\/)((0[0-9])|([12])([0-9]?)|(3[0]?))(-|\/)((\d{4}|\d{2})))/.test(str)
                                return isCorrectFormat || str == null || str.toString().replace(/ /g,'') == ''
                            }},
                            {name: "address", checkRegex: (str)=>{ return true}},
                            {name: "city", checkRegex: (str)=>{ return /[a-zA-Z]/.test(str) || str == null || str.replace(/ /g,'') == ''}},
                            {name: "state", checkRegex: (str)=>{ return true}},
                            {name: "zipcode", checkRegex: (str)=>{ return true}},
                          ];
      var isValid = true;
      var missingFields = "";
      var invalidFields = "";
      Object.keys(params).map((key, index)=>{
        var isRequiredField = requiredFields.indexOf(key) >= 0;
        var fieldIsEmpty = (params[key] == null || params[key].toString().replace(/ /g,'') == '');

        if((isRequiredField && fieldIsEmpty)) {
          isValid = false;

          var frags = key.split('_');
          var i = 0;
          for (i=0; i<frags.length; i++) {
            frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
          }
          frags = frags.join(' ');
          if(missingFields == "") {
            missingFields+= " "+frags;
          } else {
            missingFields+= ", "+frags;
          }

        }
      });

      if(!isValid) {
          //Replace with bootstrap modals in teh future for more customized look -Tere
          //If modal for this is implemented, combine with invalidFields and remove from this if-block.
          //modal should list both alerts at the same time (this alert and the one for regex)
          alert("Invalid Form! These fields are required: " + missingFields);
      }
      else {
        var existingValidator = null;


        Object.keys(params).map((key, index)=>{
          var isRequiredField = requiredFields.indexOf(key) >= 0;
          existingValidator = _.find(validationForFields, (field)=>{ return field.name == key});

          if(existingValidator && (!existingValidator.checkRegex(params[key])) ) {
            isValid = false;

            var frags = key.split('_');
            var i = 0;
            for (i=0; i<frags.length; i++) {
              frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            frags = frags.join(' ');
            if(invalidFields == "") {
              invalidFields+= " "+frags;
            } else {
              invalidFields+= ", "+frags;
            }
          }

        });

        if(!isValid) {
            //Replace with bootstrap modals in teh future for more customized look -Tere
            alert("Invalid Form! These fields are invalid: " + invalidFields);
        }
      }



      return isValid;

    }

    strToPhoneNumber(str) {
      var cleaned = ('' + str).replace(/\D/g, '')

      //Show formatted, but store numbers only. I don't have to regex nmn pla e, force store as displayed lg
      return new AsYouType('US').input(cleaned);
    }
}

export default EditUser;
